import React from "react";
import PropertyHomeIcon  from "../../../assets/images/icon-how-1.svg";
import RetailerHomeIcon  from "../../../assets/images/icon-how-2.svg";
import DocumentsHomeIcon from "../../../assets/images/icon-how-3.svg";
import KeysHomeIcon      from "../../../assets/images/icon-how-4.svg";
import "./HowItWorks.css";

const STEPS = [
  {
    icon:  PropertyHomeIcon,
    title: "Find Property",
    text:  "Explore a wide range of properties available for sale or rent across India. Our platform offers a seamless search experience to help you find the perfect home or commercial space.",
  },
  {
    icon:  RetailerHomeIcon,
    title: "Meet an Expert",
    text:  "Connect with experienced agents and brokers who specialise in the properties you need. Get personalised guidance through every step of buying, selling, or renting.",
  },
  {
    icon:  DocumentsHomeIcon,
    title: "Handle Documents",
    text:  "Simplify paperwork with our streamlined tools. Manage all necessary real estate documents efficiently for a smooth, hassle-free transaction.",
  },
  {
    icon:  KeysHomeIcon,
    title: "Take the Keys",
    text:  "Once everything is finalised, take possession of your new property and move in. Enjoy the excitement of stepping into your dream home, stress-free.",
  },
];

const HowItWorks = () => (
  <section className="hiw">
    <div className="hiw__container">

      <div className="hiw__header">
        <div className="hiw__header-left">
          <span className="hiw__label">How it works</span>
          <h2 className="hiw__title">
            Find a <em>Perfect Home</em>
          </h2>
        </div>
      </div>

      <div className="hiw__grid">
        {STEPS.map(({ icon, title, text }, i) => (
          <div key={title} className="hiw__step">
            <span className="hiw__step-number">0{i + 1}</span>
            <div className="hiw__step-icon">
              <img src={icon} alt={title} />
            </div>
            <h3 className="hiw__step-title">{title}</h3>
            <p className="hiw__step-text">{text}</p>
          </div>
        ))}
      </div>

    </div>
  </section>
);

export default HowItWorks;